import en_GB from './mla-contact-details/en_GB'
import it_IT from './mla-contact-details/it_IT'
import pt_PT from './mla-contact-details/pt_PT'
import es_ES from './mla-contact-details/es_ES'

const countrySettings = {
  'en_GB': en_GB,
  'it_IT': it_IT,
  'pt_PT': pt_PT,
  'es_ES': es_ES,
  'default': {
    'clocks': [
      'clock0800_1000',
      'clock1000_1200',
      'clock1200_1400',
      'clock1400_1600',
      'clock1600_1800'
    ],
    'permanentRequiredFields': [
      'RequestInterest',
      'Salutation',
      'FirstName',
      'LastName',
      'Email',
      'Phone'
    ],
    'requiredFields': {
      'default': [
        'Company',
        'PostalCode'
      ],
      'consulting': [
        'Company',
        'PostalCode',
        'RequestTopic'
      ],
      'offersGeneral': [
        'Company',
        'PostalCode',
        'RequestTopic'
      ],
      'offersInvestment': [
        'PostalCode'
      ],
      'other': [
        'RequestMessage'
      ],
      'customer_serviceGeneral': [
        'Company',
        'PostalCode',
        'RequestTopic',
        'RequestMessage'
      ],
      'customer_serviceBank': [
        'RequestTopic',
        'RequestMessage'
      ],
      'investor_relations': [
        'RequestMessage'
      ],
      'career': [
        'RequestMessage'
      ],
      'press': [
        'RequestMessage'
      ],
      'cooperation': [
        'Company',
        'PostalCode',
        'RequestTopic',
        'RequestMessage'
      ]
    }
  }
}

function countryClocks (countryCode) {
  return countrySettings[countryCode] && countrySettings[countryCode].clocks ? countrySettings[countryCode].clocks : countrySettings['default'].clocks
}

function countryPermanentRequiredFields (countryCode) {
  return countrySettings[countryCode] && countrySettings[countryCode].permanentRequiredFields ? countrySettings[countryCode].permanentRequiredFields : countrySettings['default'].permanentRequiredFields
}

function countryRequiredFields (countryCode, interest) {
  let requiredFields = [].concat(
    countryPermanentRequiredFields(countryCode),
    countryClocks(countryCode),
    countrySettings[countryCode] && countrySettings[countryCode].requiredFields && countrySettings[countryCode].requiredFields[interest] ? countrySettings[countryCode].requiredFields[interest] : countrySettings['default'].requiredFields[interest]
  )

  return requiredFields
}

export {
  countryClocks,
  countryRequiredFields,
  countryPermanentRequiredFields
}
